import styled from 'styled-components';
import { isMobile } from 'react-device-detect';

const mobileStyles = `
  align-items: center;
  width: 100%;
  font-size: 0.75rem;
  p:first-child {
    font-size: 0.8rem;
    font-weight: 600;
}
`
const desktopTitleStyles = `
  padding: 0.5rem;
  padding-left: 1.25rem;
  cursor: default;
`

export const SummarySectionContainer = styled.div`
  color: ${(props) => props.theme.bonusPaidDaysColor};
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: ${() => !isMobile ? '0.5rem' : '' };
  ${() => {
    if (isMobile) {
      return mobileStyles;
    } 
  }};
`;

export const SummaryOption = styled.div`
  color: ${(props) => props.theme.bonusPaidDaysOptionColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    font-weight: ${() => isMobile ? '500' : '600' };
    cursor: ${() => !isMobile ? 'default' : '' };
  }
`;

export const SummaryContainer = styled.div`
  background: ${(props) => props.theme.colorNeutralBackground1};
  display: flex;
  flex-direction: column;
  height: fit-content;
  border-radius: 1px;
  width: ${() => !isMobile ? '100%' : 'auto'};
`;

export const SummaryTitle = styled.h2`
  background: ${(props) => props.theme.colorNeutralBackground2};
  display: flex;
  align-items: center;
  font-weight: 600;
  border-bottom: 2px solid
    ${(props) => props.theme.colorNeutralBackground2Pressed};
  position: relative;
  ${() => {
    if (!isMobile) {
      return desktopTitleStyles;
    } 
  }};
`;
